import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import config from '../../../../config';
import withRouter from '../../../../components/Router/WithRouter';
import { Button } from 'reactstrap';

function getRoutes() {
	return [
		{
			to: '/',
			name: 'dashboardTitle',
			picto: 'tachometer',
		},
		{
			to: '/user/profile',
			name: 'userAccountMy',
			picto: 'user-alt',
			allowedRoles: ['student'],
		},
		{
			to: '/sessions',
			name: 'sessionsMy',
			picto: 'graduation-cap',
		},
		{
			type: 'divider',
		},
		{
			type: 'title',
			name: 'administrationTitle',
			allowedRoles: ['root', 'admin', 'manager', 'professor', 'redactor'],
		},
		{
			to: '/console/institutions',
			name: 'institutions',
			picto: 'university',
			allowedRoles: ['root', 'admin', 'manager'],
		},
		{
			to: '/console/users/dashboard',
			name: 'users',
			picto: 'users',
			allowedRoles: ['root', 'admin', 'manager', 'professor'],
			routes: [
				{
					to: '/console/user/edit',
					name: 'userAdd',
					picto: 'user-plus',
					allowedRoles: ['root', 'admin', 'manager'],
				},
			],
		},
		// {
		//     to: '/console/themes',
		//     name: 'themes',
		//     picto: 'tags',
		//     allowedRoles: ['admin', 'manager'],
		// },
		// {
		//     type: 'divider',
		//     allowedRoles: ['admin', 'manager'],
		// },
		// {
		//     type: 'title',
		//     name: 'sessionCreationTitle',
		//     allowedRoles: ['admin', 'manager', 'professor', 'redactor'],
		// },
		// {
		//     to: '/console/subject/centrale',
		//     name: 'subjectCentrale',
		//     picto: 'bullseye',
		//     allowedRoles: ['admin', 'manager', 'professor', 'redactor'],
		// },
		{
			to: '/console/subjects/dashboard',
			name: 'subjectTitle',
			picto: 'edit',
			allowedRoles: ['root', 'admin', 'manager', 'professor', 'redactor'],
		},
		// {
		//     type: 'divider',
		//     allowedRoles: ['admin', 'manager', 'professor', 'redactor'],
		// },
		// {
		//     type: 'title',
		//     name: 'sessionsTitle',
		//     allowedRoles: ['admin', 'manager', 'professor', 'proctor'],
		// },
		{
			to: '/console/sessions/dashboard',
			name: 'sessionsTitle',
			picto: 'paper-plane',
			allowedRoles: ['root', 'admin', 'manager', 'professor'],
		},
		// {
		//     to: '/console/sessions/pending',
		//     name: 'sessionPendingTitle',
		//     picto: 'paper-plane',
		//     allowedRoles: ['admin', 'manager', 'professor'],
		// },
		// {
		//     to: '/console/sessions/onprogress',
		//     name: 'sessionOnProgressTitle',
		//     picto: 'play',
		//     allowedRoles: ['admin', 'manager', 'professor', 'proctor'],
		// },
		// {
		//     type: 'divider',
		//     allowedRoles: ['admin', 'manager', 'professor', 'proctor'],
		// },
		// {
		//     type: 'title',
		//     name: 'sessionCorrectTitle',
		//     allowedRoles: ['admin', 'manager', 'professor', 'corrector'],
		// },
		// {
		//     to: '/console/sessions/oncorrection',
		//     name: 'sessionOnCorrectionTitle',
		//     picto: 'pencil-ruler',
		//     allowedRoles: ['admin', 'manager', 'professor', 'corrector'],
		// },
		// {
		//     to: '/console/sessions/over',
		//     name: 'sessionOverTitle',
		//     picto: 'check-circle',
		//     allowedRoles: ['admin', 'manager', 'professor'],
		// },
		// {
		//     to: '/console/sessions/archived',
		//     name: 'sessionArchivesTitle',
		//     picto: 'archive',
		//     allowedRoles: ['admin', 'manager'],
		// },
		// {
		//     type: 'divider',
		//     allowedRoles: ['admin', 'manager', 'professor', 'corrector'],
		// },
		// {
		//     type: 'title',
		//     name: 'invoiceTitle',
		//     allowedRoles: ['admin', 'manager'],
		// },
		{
			to: '/console/invoices/dashboard',
			name: 'invoiceTitle',
			picto: 'suitcase',
			allowedRoles: ['root', 'admin'],
		},
		// {
		//     to: '/console/invoice/quote',
		//     name: 'invoiceQuoteTitle',
		//     picto: 'suitcase',
		//     allowedRoles: ['admin', 'manager'],
		// },
		// {
		//     to: '/console/invoice/invoice',
		//     name: 'invoiceInvoiceTitle',
		//     picto: 'file-invoice-dollar',
		//     allowedRoles: ['admin', 'manager'],
		// },
		{
			to: '/console/contents',
			name: 'CMS',
			picto: 'book-open',
			allowedRoles: ['root'],
			// allowedInstitutions: ['*'],
		},
		{
			to: '/console/config',
			name: 'configuration',
			picto: 'cogs',
			allowedRoles: ['root'],
			// allowedInstitutions: ['*'],
		},
	];
}

function isRouteAllowed(route, user) {
	return (
		!route.allowedRoles
            || (user && user.role && route.allowedRoles.includes(user.role))
	)
        && (
        	!route.allowedInstitutions
            || (user && user.role && route.allowedInstitutions.some(institution => user.institutions.includes(institution)))
        );
}

function renderRoutes(routes, user, location) {
	return routes
		.filter(route => isRouteAllowed(route, user))
		.map((route, index) => {
			if(route.type === 'divider') {
				return <hr key={index} className="border-secondary my-1" />;
			}
			if(route.type === 'title') {
				return (
					<li key={index} className="nav-item">
						<span className="nav-link text-white-50 text-uppercase small fw-bold px-3 py-1" style={{ fontSize: '0.65rem', letterSpacing: '0.05rem' }}>
							<FormattedMessage id={route.name} />
						</span>
					</li>
				);
			}
			return (
				<li key={index} className="nav-item py-2">
					<Link
						to={route.to}
						className={`nav-link d-flex flex-column align-items-center py-2 text-center ${location.pathname === route.to ? 'active text-white' : 'text-white'}`}
					>
						<FontAwesomeIcon icon={route.picto} size="lg" fixedWidth />
						<span className="small mt-1" style={{ fontSize: '0.7rem' }}><FormattedMessage id={route.name} /></span>
					</Link>
					{/* {route.routes && (
                        <ul className="navbar-nav flex-column ps-3">
                            {renderRoutes(route.routes, user, location)}
                        </ul>
                    )} */}
				</li>
			);
		})
		.filter(Boolean);
}

const Menu = ({ user, location, intl }) => {
	const [isOpen, setIsOpen] = useState(false);
	const menu = useRef(null);

	// Publish the menu width as a custom property: elements fixed on the viewport (the exam
	// banner for instance) cannot know it otherwise, and it changes with the breakpoints.
	useEffect(() => {
		const node = menu.current;
		if(!node || typeof ResizeObserver === 'undefined') {
			return undefined;
		}
		const publishWidth = () => {
			document.documentElement.style.setProperty('--app-menu-width', `${node.offsetWidth}px`);
		};
		publishWidth();
		const observer = new ResizeObserver(publishWidth);
		observer.observe(node);
		return () => {
			observer.disconnect();
			document.documentElement.style.removeProperty('--app-menu-width');
		};
	}, [user]);

	if(!user) {
		return null;
	}

	return (
		<nav className="bg-dark" aria-label="Menu principal" ref={menu}>
			<a href="#main-content" className="visually-hidden-focusable">
				<FormattedMessage id="skipToMainContent" defaultMessage="Skip to main content" />
			</a>

			{/* Toggler — mobile/tablette uniquement */}
			<div className="d-lg-none p-1 pt-2">
				<Link to="/" className="d-block text-center">
					<img src="/assets/images/favicon.png" alt={config.application.name} height="32" />
				</Link>
				<Button
					color="link"
					className="d-block w-100 border-0 mt-2 p-1 text-center"
					onClick={() => setIsOpen(!isOpen)}
					aria-expanded={isOpen}
					aria-label={intl.formatMessage({ id: 'toggleNavigation', defaultMessage: 'Toggle navigation' })}
				>
					<span className="text-white"><FontAwesomeIcon icon={isOpen ? 'times' : 'grip'} size="lg" /></span>
				</Button>
			</div>

			{/* Contenu du menu — toujours visible sur desktop, togglable sur mobile */}
			<div className={isOpen ? 'd-block' : 'd-none d-lg-block'}>
				{/* Logo — desktop uniquement */}
				<div className="d-none d-lg-flex justify-content-center py-3">
					<Link to="/">
						<img
							src="/assets/images/favicon.png"
							alt={config.application.name}
							title={intl.formatMessage({ id: 'appHomeGo', defaultMessage: 'Go to home' })}
						/>
					</Link>
				</div>

				<ul className="navbar-nav flex-column py-2">
					{renderRoutes(getRoutes(), user, location)}
				</ul>
			</div>
		</nav>
	);
};

Menu.propTypes = {
	location: PropTypes.object.isRequired,
	intl: PropTypes.object.isRequired,
	user: PropTypes.object,
};

function mapStateToProps(store) {
	return {
		user: store.users.user,
	};
}

export default connect(mapStateToProps)(withRouter(withIntl(Menu)));
